import _ from 'lodash';
import { MutationTree } from 'vuex';
import {
  TimesheetsState,
  Timesheet,
  WorkSummaryDiff,
  TimesheetConditions,
  yearlyworkdays,
} from '@/store/timesheets/types';
import { Pager } from '../pager.types';
import { Sort } from '../sort.types';

const mutations: MutationTree<TimesheetsState> = {
  fetchedTimesheet: (
    state, payload: {
      timesheets: Timesheet[],
      conditions: TimesheetConditions,
      pager: Pager,
      sortBy: Sort,
    },
  ) => {
    state.timesheets = payload.timesheets
    state.conditions = payload.conditions
    state.pager = payload.pager
    state.sortBy = payload.sortBy
  },
  gotTimesheet: (
    state,
    timesheet: Timesheet,
  ) => {
    const ymd = timesheet.date.format('YYYYMMDD')
    state.timesheets = _.uniqBy([
      timesheet,
      ...state.timesheets,
    ], (t: Timesheet) => {
      return `${t.tutor?.id}${t.date.format('YYYYMM')}`
    })
  },

  gotWorkSummaryDiff: (
    state,
    WorkSummaryDiffs: WorkSummaryDiff[],
  ) => {
    state.WorkSummaryDiffs = WorkSummaryDiffs
  },

  gotYearlyWorkingDay: (state, data: yearlyworkdays[]) => {
    state.yearlyworkdays = data
  },
}

export default mutations
